module.exports = "https://static.wanderu.com/static/media/bus-grey.661497ce.svg";